import {AfterViewInit, Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {AppService} from '../../commons/app.service';
import {ActivatedRoute, Router} from '@angular/router';
import {MatDialog, MatSnackBar} from '@angular/material';
import {TranslateService} from '@ngx-translate/core';


import {MainComponent} from '../main.component';
import {MainService} from '../main.service';


import {VasatSearchQuery} from 'vasat'
import {Annotation, FourdCesiumHelper, FourDService, Project, Transform, TransformType,Job,JobType,JobBatch} from '4d-mapper';
import {AppBaseComponent} from '../../commons/AppBaseComponent';
import { XsApplicationEventsService } from '../../xs/services/events/application-events.service';

const Cesium = (<any>window).Cesium;

@Component({
  selector: 'jobs-comp',
  templateUrl: './job-list.component.html',
  styleUrls: ['./job-list.component.scss']
})
export class JobListComponent extends AppBaseComponent implements OnInit, OnDestroy {

  jobs:VasatSearchQuery<Job>

  selectedJob:Job

  constructor(private fourD: FourDService, public service: AppService, private r: Router, sn: MatSnackBar, d: MatDialog, 
    private ar: ActivatedRoute, private t: TranslateService, private mainComponent: MainComponent, private mainService: MainService, 
    private trans: TranslateService, applicationEvents:XsApplicationEventsService) {
    super(service, r, sn, d, applicationEvents);
  }
  
  onReady(){
    this.jobs =  this.fourD.V.searchByObject(Job)
    this.jobs.queryObservable().subscribe()
  }

  addNew(jt:JobType){
    var name = prompt('Name for job (do this nicer)')
    if(!name) return
    var job = new Job(this.fourD.V).set({
      name:name,
      account:this.fourD.activeTeam,
      jobType:jt
    }).saveObservable().subscribe(res => this.selectedJob = res)

  }
}

